import { useEffect, useRef, useState } from "react";
import StudyStatusViewer from "./StudyStatusViewer.js";
import IssuesSummary from "./IssuesSummary.js";
import StudyStatusEditor from "./StudyStatusEditor.js";
import IssuesDetails from "./IssuesDetails.js";
import axios from "axios";
import { useSelector } from "react-redux";
import { createGlobalStyle } from "styled-components";
import { toastMsg } from "../utils.js";
import styled from "styled-components";
import { getReportDivision } from "../access";

const StatusAndIssuesWrapper = styled.div`
  display: ${(props) => (props.mode === "read" ? "grid" : "flex")};
  width: 100%;
  grid-template-columns: repeat(2, 50%);
  gap: 16px;
  max-width: "99vw";
`;

const ScrollSmooth = createGlobalStyle`
  html {
    scroll-behavior: smooth;
  }
`;

const StatusAndIssues = ({
  contrNo,
  isEditable,
  isEnrollmentStatusUsed,
  projectListRef,
  yearMonth,
}) => {
  const [mode, setMode] = useState("read");
  const [studyStatusDataSource, setStudyStatusDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);
  const reportDiv = getReportDivision(userInfo.div);

  useEffect(() => {
    // * contrNo가 바뀌면 mode를 "read"로 설정.
    setMode("read");
  }, [contrNo]);

  useEffect(() => {
    //! api R8. Get the study status
    if (contrNo && yearMonth && mode === "read") {
      setStudyStatusDataSource(null);
      axios
        .get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/mthlyReport/proj/studyStatus/${yearMonth}/${contrNo}`
        )
        .then((res) => {
          setStudyStatusDataSource(res.data);
        })
        .catch((err) => {
          toastMsg(`에러가 발생했습니다. 관리자에게 문의해주세요.`, false);
          throw err;
        });
    }
    // 아래쪽으로 scroll
    // setTimeout(() => {
    //   window.scrollTo({ top: document.body.scrollHeight });
    // }, 500);
  }, [contrNo, mode]);

  return (
    <StatusAndIssuesWrapper mode={mode}>
      <ScrollSmooth />
      {studyStatusDataSource && mode === "read" && (
        <>
          <StudyStatusViewer
            contrNo={contrNo}
            isEditable={isEditable}
            isEnrollmentStatusUsed={isEnrollmentStatusUsed}
            setMode={setMode}
            studyStatusDataSource={studyStatusDataSource}
            yearMonth={yearMonth}
          />
          <IssuesSummary
            contrNo={contrNo}
            setMode={setMode}
            yearMonth={yearMonth}
          />
        </>
      )}
      {mode === "statusEdit" && (
        <StudyStatusEditor
          contrNo={contrNo}
          projectListRef={projectListRef}
          setMode={setMode}
          studyStatusDataSource={studyStatusDataSource[reportDiv]}
          yearMonth={yearMonth}
        />
      )}
      {mode === "issueEdit" && (
        <IssuesDetails
          contrNo={contrNo}
          isEditable={isEditable}
          projectListRef={projectListRef}
          setMode={setMode}
          yearMonth={yearMonth}
        />
      )}
    </StatusAndIssuesWrapper>
  );
};

export default StatusAndIssues;
